import type { BackendTypes } from '@tf/api';
import type { FilterItem } from '@tf/ui';

import { getDisplayName } from '@/core/utils';

const STATUS_OPTIONS = [
	{ value: 'PROSPECT', label: 'Prospect' },
	{ value: 'ACTIVE', label: 'Active' },
	{ value: 'SUSPENDED', label: 'Suspended' },
	{ value: 'REJECTED', label: 'Rejected' },
	{ value: 'CLOSED', label: 'Closed' },
	{ value: 'ARCHIVED', label: 'Archived' },
];

const VERIFICATION_OPTIONS = [
	{ value: 'DRAFT', label: 'Draft' },
	{ value: 'READY_TO_REVIEW', label: 'Ready to review' },
	{ value: 'UNDER_REVIEW', label: 'Pending review' },
	{ value: 'VERIFIED', label: 'Verified' },
	{ value: 'UPDATE_REQUIRED', label: 'Update required' },
];

const PRIORITY_OPTIONS = [
	{ value: 'HIGH', label: 'High' },
	{ value: 'MEDIUM', label: 'Medium' },
	{ value: 'LOW', label: 'Low' },
];

const UNASSIGNED_OPTION = { value: '__unassigned__', label: 'Not assigned' };

export const getAccountsFilters = (
	users: BackendTypes.UserInfo[],
	accountKinds: { value: string; label: string }[]
): FilterItem[] => {
	return [
		{
			name: 'kind',
			label: 'Account type',
			type: 'select',
			value: accountKinds,
		},
		{
			name: 'values.accountStatus',
			label: 'Account status',
			type: 'select',
			value: STATUS_OPTIONS,
		},
		{
			name: 'verification',
			type: 'select',
			label: 'Verification status',
			value: VERIFICATION_OPTIONS,
		},
		{
			name: 'importance',
			type: 'select',
			label: 'Priority',
			value: PRIORITY_OPTIONS,
		},
		{
			name: 'assignedTo',
			type: 'select',
			label: 'Assigned manager',
			value: [
				UNASSIGNED_OPTION,
				...(users?.map((user) => ({ value: user.userId, label: getDisplayName(user) })) || []),
			],
		},
	];
};

export const getProfilesFilters = (
	users: BackendTypes.UserInfo[],
	kindsOptions: { value: string; label: string }[],
	groupKinds: string[]
): FilterItem[] => {
	return [
		{
			name: 'kind',
			label: 'Type',
			type: 'select',
			value: kindsOptions?.filter((option) => groupKinds.includes(option.value)) ?? [],
		},
		{
			name: 'values.accountStatus',
			label: 'Status',
			type: 'select',
			value: STATUS_OPTIONS,
		},
		{
			name: 'verification',
			type: 'select',
			label: 'Verification status',
			value: VERIFICATION_OPTIONS,
		},
		{
			name: 'importance',
			type: 'select',
			label: 'Priority',
			value: PRIORITY_OPTIONS,
		},
		{
			name: 'assignedTo',
			type: 'select',
			label: 'Assigned manager',
			value: [
				UNASSIGNED_OPTION,
				...(users?.map((user) => ({ value: user.userId, label: getDisplayName(user) })) || []),
			],
		},
	];
};
